import React, { Component, Fragment } from 'react';
import { withAITracking } from '@microsoft/applicationinsights-react-js';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import { ai } from '../services/TelemetryService';
import InterceptorAxios from './InterceptorAxios';
import { RequestHeaders } from '@microsoft/applicationinsights-common';
import { v4 as uuidv4 } from 'uuid';

type IPathParamsType = {
}
interface IStateProps {
    history: History
}

interface IState {
    initialized: boolean
}
interface IProps {
    instrumentationKey: string
}
type PropsType = RouteComponentProps<IPathParamsType> & IStateProps & IProps;

/**
 * This Component provides telemetry with Azure App Insights
 *
 * NOTE: the package '@microsoft/applicationinsights-react-js' has a HOC withAITracking that requires this to be a Class Component rather than a Functional Component
 */
class TelemetryProvider extends Component<PropsType, IState> {
    state = {
        initialized: false
    };

    componentDidMount() {
        const { history } = this.props;
        const { initialized } = this.state;
        const AppInsightsInstrumentationKey = this.props.instrumentationKey; // PUT YOUR KEY HERE
        if (!initialized && AppInsightsInstrumentationKey && history) {
            ai.initialize(AppInsightsInstrumentationKey, history);
            this.setState({ initialized: true });
            
            if (ai.appInsights) {
                const appInsightsContext = ai.appInsights.context as any;
                const telemetryTrace = appInsightsContext?.telemetryTrace;
                const correlationId = telemetryTrace?.traceID || uuidv4();
                if (telemetryTrace) {
                    telemetryTrace.traceID = correlationId;
                }
                ai.appInsights.addTelemetryInitializer((envelope) => {
                    if (envelope.tags) {
                        envelope.tags[RequestHeaders.requestIdHeader] = correlationId;
                    }
                });
                
                ai.appInsights.trackEvent({
                    name: 'TelemetryInitialized',
                    properties: { timestamp: new Date().toISOString(), correlationId: InterceptorAxios.correlationId }
                });
            }
        }
    }

    render() {
        const { children } = this.props;
        return (
            <Fragment>
                {children}
            </Fragment>
        );
    }
}

export default withRouter(withAITracking(ai.reactPlugin!, TelemetryProvider));
